import { Globe, Linkedin, Youtube, Sparkles, ShieldCheck } from 'lucide-react'
import { useLocation, Link } from 'react-router-dom'

export function Footer() {
  const location = useLocation()
  const currentYear = new Date().getFullYear()

  // Don't show footer on admin pages or solution designer
  if (location.pathname.startsWith('/admin') || location.pathname === '/solutions/designer') {
    return null
  }

  return (
    <footer className="bg-white/95 dark:bg-gray-900/95 backdrop-blur-lg border-t border-gray-200/50 dark:border-gray-700/50">
      <div className="container mx-auto px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:grid sm:grid-cols-3 items-center space-y-2 sm:space-y-0">

          {/* Logo and Copyright */}
          <div className="flex items-center space-x-1 sm:justify-self-start">
            <img
              src="/logo/new/WESTCOAST_dark.png"
              alt="Westcoast Logo"
              className="h-16 sm:h-20 w-auto block dark:hidden transition-all duration-200"
            />
            <img
              src="/logo/new/WESTCOAST_light.png"
              alt="Westcoast Logo"
              className="h-16 sm:h-20 w-auto hidden dark:block transition-all duration-200"
            />
            <p className="text-sm text-gray-600 dark:text-gray-400">
              © {currentYear} Westcoast Ltd.
            </p>
          </div>

          {/* Designer Attribution - Center on desktop */}
          <div className="hidden sm:flex sm:justify-center">
            <a
              href="https://www.linkedin.com/in/jacktokarski/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-300"
            >
              <Sparkles className="h-3.5 w-3.5 group-hover:text-blue-500 group-hover:animate-pulse transition-colors" />
              <span className="font-medium">Designed by JT</span>
              <Linkedin className="h-3.5 w-3.5 opacity-70 group-hover:opacity-100 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all" />
            </a>
          </div>

          {/* Social Links and Privacy - Right side on desktop */}
          <div className="hidden sm:flex sm:justify-end sm:justify-self-end gap-4">
            <Link
              to="/privacy-policy"
              className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
              title="Privacy Policy"
            >
              <ShieldCheck className="h-5 w-5" />
            </Link>
            <a
              href="https://www.westcoast.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
              title="Visit Westcoast Website"
            >
              <Globe className="h-5 w-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/westcoast-limited"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
              title="Follow us on LinkedIn"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://www.youtube.com/@WestcoastLimited"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
              title="Subscribe to our YouTube channel"
            >
              <Youtube className="h-5 w-5" />
            </a>
          </div>

          {/* Mobile Layout */}
          <div className="sm:hidden w-full">
            {/* Designer Attribution - Mobile */}
            <div className="flex justify-center mb-3">
              <a
                href="https://www.linkedin.com/in/jacktokarski/"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-300"
              >
                <Sparkles className="h-3.5 w-3.5 group-hover:text-blue-500 group-hover:animate-pulse transition-colors" />
                <span className="font-medium">Designed by JT</span>
                <Linkedin className="h-3.5 w-3.5 opacity-70 group-hover:opacity-100 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all" />
              </a>
            </div>
            {/* Social Links and Privacy - Mobile */}
            <div className="flex gap-4 justify-center">
              <Link
                to="/privacy-policy"
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
                title="Privacy Policy"
              >
                <ShieldCheck className="h-5 w-5" />
              </Link>
              <a
                href="https://www.westcoast.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
                title="Visit Westcoast Website"
              >
                <Globe className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/westcoast-limited"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
                title="Follow us on LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="https://www.youtube.com/@WestcoastLimited"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200"
                title="Subscribe to our YouTube channel"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}